import { AlertButton, AlertController, Platform } from '@ionic/angular';
import { BUSNQuestionService, BUSNUserService } from '@takectrl-multiapp/svcs-core-business';
import { Component, NgZone, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import {
  AssetType,
  SharedDialogService,
  IPostalCodeArea,
  IPostalCodes,
  IQuestion,
  SharedConfig,
  UnderwritingAnswer,
  AddressSelectorScreen,
  IPostalCodeAreas,
  IPostalDetails,
  QuoteRequestType,
} from '@takectrl-multiapp/svcs-share-config';
import { PostalCodeType, AdditionalAddressKeys } from '@takectrl-multiapp/svcs-core';
import { APIHttpService } from 'libs/svcs-ctrl-api/src/lib/services/api-http.service';
import * as _ from 'lodash';

export interface IPostalCodeMatched {
  postal_code?: string;
  postal_code_id?: string;
  score?: number;
  suburb_name?: string;
}

export interface IPostalCode {
  line1?: string;
  line2?: string;
  matched?: {
    mnfg?: IPostalCodeMatched[];
    sa02?: IPostalCodeMatched[];
    sapo?: IPostalCodeMatched[];
  };
  postal_code?: string;
  unmatched?: {
    mnfg?: IPostalCodeMatched[];
    sa02?: IPostalCodeMatched[];
    sapo?: IPostalCodeMatched[];
  };
}

export interface IPostalCodeDetails extends IPostalCode{
  street_number?: string;
  street_name?: string;
  suburb?: string;
  city?: string;
  district?: string;
  province?: string;
  country?: string;
  longitude?: number;
  latitude?: number;
}

@Component({
  selector: 'input-text-address',
  standalone: false,
  templateUrl: './input-text-address.component.html',
  styleUrls: ['./input-text-address.component.scss'],
})
export class InputTextAddressComponent implements OnInit, AfterViewInit {
  @Input() question: IQuestion;
  @Input() showHeading: boolean;
  @Input() error: string;
  @Input() page: string;
  @Input() readOnly: boolean;
  @Output() answerQuestion: EventEmitter<IQuestion> = new EventEmitter();
  @ViewChild('streetAddressInput') streetInputOne;
  @ViewChild('postalInput') postalInputOne;
  AddressSelectorScreen = AddressSelectorScreen;
  QuoteRequestType = QuoteRequestType
  public streetAddress: string;
  public postalCode: string;
  address: string;

  public postalCodeUnderwritingAnswer: UnderwritingAnswer;
  public addressLine1UnderwritingAnswer: UnderwritingAnswer;
  public addressLine2UnderwritingAnswer: UnderwritingAnswer;
  public postalCodeIdUnderwritingAnswer: UnderwritingAnswer;
  public postalCodeIdMNFGUnderwritingAnswer: UnderwritingAnswer;
  public postalCodeIdSA02UnderwritingAnswer: UnderwritingAnswer;

  private googleMapsUnderwritingAnswers: UnderwritingAnswer[];

  postalCodes: IPostalCodeArea[];
  postalCodesMNFG: IPostalCodeArea[];
  postal_codes_sa02: IPostalCodeArea[];
  currentPostalCodes: IPostalCodeArea[];
  currentPostalResultsShown: PostalCodeType = 'None';
  chosenPostalCodes: IPostalCodes = {};
  showNothingFound = false;
  //@ts-ignore https://developers.google.com/maps/documentation/javascript/libraries
  autocomplete: google.maps.places.Autocomplete;
  searchValue: string;
  searchTimedOut = false;
  searchedAddresses: any[] = [];
  postalResult: IPostalCodeDetails = {};
  inputTextAddressShowScreenID: string;

  keyDownCurrentIndex = 0;
  keyDownPressIndex = 0;

  enableAddressFreeText = false;
  showPostalResultsMNFG = false;
  showPostalResultsSA02 = false;
  checkedMNFG: boolean;
  checkedSA02: boolean;
  postalCodesMNFGSaveValue = [];
  postalCodesSA02SaveValue = [];
  selectedSearchResMNFG: any;
  objectNameType: AssetType;
  nothingFoundError = false;
  //@ts-ignore https://developers.google.com/maps/documentation/javascript/libraries
  placeService: google.maps.places.PlacesService;
  partialPostalLookupList: IPostalCodeMatched[];
  postalCodeAreas: IPostalCodeAreas;
  sub_loader: boolean = false;
  constructor(
    private readonly alertController: AlertController,
    public httpService: APIHttpService,
    private readonly zone: NgZone,
    public sharedDialogService: SharedDialogService,
    public busnUserService: BUSNUserService,
    public busnQuestionService: BUSNQuestionService,
    public sharedConfig: SharedConfig,
    public platform: Platform
  ) {

  }

  ngAfterViewInit(): void {}

  ngOnInit(): void {
    
  }

  onAddressSelected(addressId: number) {
    this.question.underwriting_answers[0].object_answer = addressId
    console.log(addressId);
    this.answerQuestion.emit(this.question);
  }
}
